/**
 * Nightcap — Sticky Add-to-Cart Web Component
 * Shows a fixed bottom bar on mobile when #product-module scrolls out of view.
 * Tapping the CTA smooth-scrolls back to the purchase module.
 */
class NcStickyAtc extends HTMLElement {
  connectedCallback() {
    var self = this;
    var targetSelector = this.dataset.target;
    this.target = targetSelector ? document.querySelector(targetSelector) : null;

    if (!this.target) return;

    this.observer = new IntersectionObserver(
      function (entries) {
        var isVisible = entries[0].isIntersecting;
        self.classList.toggle('nc-sticky-atc--visible', !isVisible);
        self.setAttribute('aria-hidden', String(isVisible));
      },
      { threshold: 0, rootMargin: '0px' }
    );

    this.observer.observe(this.target);

    /* Scroll-to-form button — smooth-scrolls back to the purchase module */
    var scrollBtn = this.querySelector('[data-action="scroll-to-form"]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function () {
        self.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('nc-sticky-atc', NcStickyAtc);
